define('drops/calendarPlanningViewGroupItem/calendarPlanningViewGroupItem',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/constants'
], function ($, _, Drop, Style, constants) {
    'use strict';

    var defaults = {
        data: {
            position: { x: 0, y: 0 },
            size: { x: 80, y: 60 }
        }
    };

    function CalendarPlanningViewGroupItem(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        this.$element
            .addClass('group-item boxToBorderSize')
            .css({
                touchAction: 'auto'
            });

        this.addListener('ChildRendered', function (childDrop) {
            self.applyDataToChild(childDrop);
        });

        Style.renderStyles(this);
    }

    Drop.extend(CalendarPlanningViewGroupItem, Drop);

    CalendarPlanningViewGroupItem.typeName = 'GroupItem';

    CalendarPlanningViewGroupItem.prototype.preRender = function () {
        // no-op
    };

    CalendarPlanningViewGroupItem.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    CalendarPlanningViewGroupItem.prototype.postRender = function () {
        this.applyDataToChildren();
    };

    CalendarPlanningViewGroupItem.prototype.applyDataToChild = function (childDrop) {
        childDrop.defaultEventArg = this.data.groupId;
    };

    CalendarPlanningViewGroupItem.prototype.applyDataToChildren = function () {
        var row = this.data.groupRow || {};
        var outputs = this.data.groupOutputs || {};
        var self = this;

        var applyToDrop = function (drop) {
            if (drop.setValue && drop.data && drop.data.name && _.has(row, drop.data.name)) {
                var outputType = outputs[drop.data.name] || constants.valueTypes.string;
                drop.setValue({
                    type: outputType,
                    value: row[drop.data.name]
                });
            }
            drop.informListeners('DatasourceApplied', {
                groupId: self.data.groupId,
                groupRow: row
            });
            _.each(drop.pool || [], applyToDrop);
        };
        _.each(this.pool, applyToDrop);
    };

    CalendarPlanningViewGroupItem.prototype.applyPosition = function () {
        var w = this.data.size && this.data.size.x != null ? this.data.size.x : 80;
        var h = this.data.size && this.data.size.y != null ? this.data.size.y : 60;
        this.$element.css({
            width: w + 'px',
            height: h + 'px'
        });
        var $groupLabel = this.$element.parent();
        if ($groupLabel.length && $groupLabel.hasClass('group-label')) {
            $groupLabel.css({
                width: w + 'px',
                Height: h + 'px'
            });

            if (this.parent && typeof this.parent.updateHoursSpacerWidth === 'function') {
                this.parent.updateHoursSpacerWidth(w);
            }
        }
    };

    return CalendarPlanningViewGroupItem;
});

